import { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import {Trans, useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell} from "@fortawesome/free-solid-svg-icons";

const AlertModal = ({alertDataP, showAlert, onCloseForParent}) => 
{
    const { t, i18n: { language }/*, i18n */} = useTranslation();
    const [show, setShow] = useState(false);// for alerts
    const [alertData, setAlertData] = useState (alertDataP);
    const [alertIcon, setAlertIcon] = useState (faBell);
    
    const onClose = () => {
        //console.log ('Popup Closing ' + Math.random());
        setShow (false);
        onCloseForParent();
    };

    const onShow = () => {
        //console.log ('Popup Openning ' + Math.random());
        setShow (true);
    }
    
    let options : Intl.DateTimeFormatOptions = {
        //weekday: "long",
        //year: "numeric",
        //month: "long",
        //day: "numeric",
        dateStyle: "medium",
        timeStyle: "medium"
    };
    // Translate using the browser's localization logic, as it does french better
    const generatedAtDateTime = alertData ? new Intl.DateTimeFormat(language.substring (0, 2), options).format(new Date(alertData.created)) : "";
    const expiresAtDateTime = alertData ? new Intl.DateTimeFormat(language.substring (0, 2), options).format(new Date(alertData.expires)) : "";


    return (
        <Modal
            show={true/*show *//*showAlert*/}
            onHide={onClose}
            onShow={onShow}
            aria-labelledby="contained-modal-title-vcenter"
            centered 
            /*size={"lg"}*/
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {/*&#128276;*/} <FontAwesomeIcon icon={alertIcon} className="me-2" ></FontAwesomeIcon> <Trans i18nKey="AlertModal.title">Alert</Trans>: {alertData.subject}{/*alertData.eventTypeName*/}
                </Modal.Title>
            </Modal.Header>

            {/*alertData &&*/
                (<Modal.Body>
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <dl className="row" style={{marginBottom: 0}}>
                                <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}><Trans i18nKey="AlertModal.published">Published</Trans></dt>
                                <dd className="col-sm-8">{generatedAtDateTime}</dd>
                            </dl>
                            <dl className="row" style={{marginBottom: 0}}>
                                <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}><Trans i18nKey="AlertModal.expires">Active Until</Trans></dt>
                                <dd className="col-sm-8">{expiresAtDateTime}</dd>
                            </dl>
                           {/* <dl className="row" style={{marginBottom: 0}}>
                                <dt className="col-sm-4" style={{textAlign: "right", padding: 0}}>Region Affected</dt>
                                <dd className="col-sm-8">{alertData.regionName}</dd>
                            </dl>*/}
                            <div dangerouslySetInnerHTML={{ __html: alertData.description }} />
                        </div>
                    </div>
                </Modal.Body>)
            }

            {/*<Modal.Footer>
                &nbsp;
            </Modal.Footer>*/}
        </Modal>
    );
}


export default AlertModal;